import { Flow } from "../types";
import { SCREENS } from "../screens";
import { isFinishContract, shouldCollectGDPRAgreements } from "@/utils/contract";
import { Contract } from "@/types/contract";
import { redirectToSupplyPoint, requireInkasoSetup } from "../helpers";
import { Product } from "@/types/enumerations";

const redirectCustomerToIdentification = (contract: Contract): boolean => Boolean(contract.campaign?.identification);

export const ZSP_PROCESS: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => (redirectCustomerToIdentification(contract) ? SCREENS.IDENTIFICATION : SCREENS.CUSTOMER),
    back: () => null,
  },
  [SCREENS.IDENTIFICATION]: {
    next: () => SCREENS.CUSTOMER,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: (contract: Contract, options?: { products?: Product[] }) =>
      redirectToSupplyPoint(contract, options!.products!)
        ? SCREENS.SUPPLY_POINT
        : requireInkasoSetup(contract, options!.products!)
        ? SCREENS.PAYMENTS
        : SCREENS.RECAPITULATION,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.SUPPLY_POINT]: {
    next: (contract: Contract, options?: { products?: Product[] }) =>
      requireInkasoSetup(contract, options!.products!) ? SCREENS.PAYMENTS : SCREENS.RECAPITULATION,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: (contract: Contract, options?: { products?: Product[] }) =>
      redirectToSupplyPoint(contract, options!.products!)
        ? SCREENS.SUPPLY_POINT
        : requireInkasoSetup(contract, options!.products!)
        ? SCREENS.CUSTOMER
        : SCREENS.RECAPITULATION,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) => {
      if (!options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)) {
        return SCREENS.AGREEMENTS;
      }
      if (isFinishContract(contract)) {
        return SCREENS.THANK_YOU;
      }
      return SCREENS.VIEW;
    },
    back: (contract: Contract, options?: { products?: Product[] }) =>
      redirectToSupplyPoint(contract, options!.products!) ? SCREENS.SUPPLY_POINT : SCREENS.CUSTOMER,
  },
  [SCREENS.AGREEMENTS]: {
    next: (contract: Contract) => (isFinishContract(contract) ? SCREENS.THANK_YOU : SCREENS.VIEW),
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
